import React, {memo, useEffect, useState} from 'react';
import {Box, InputLabel, Paper, Select} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {packageTypeAction, treeAction} from "../../actions";
import {connect, useDispatch} from "react-redux";
import Autocomplete from "@mui/lab/Autocomplete";
import Button from "@mui/material/Button";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import {Loading} from './../../components'
import Chip from "@mui/material/Chip";
import {FETCH_NODES} from "../../types";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";

const ProductBasicInfo = memo((props) => {


    const dispatch = useDispatch();
    const {packageTypeReducer, fetchPackageType, onComplete, productID, fetchPriceParameter, treeReducer} = props;

    const [form, setForm] = useState({});
    const [loading, setLoading] = useState(false);
    const [priceParameter, setPriceParameter] = useState([]);
    const [brands, setBrands] = useState([]);

    useEffect(() => {

        dispatch({type: FETCH_NODES, payload: []});

        fetchPriceParameter();
        fetchPackageType();

        if (productID) {
            setLoading(true);
            new Api().get('/products/' + productID + '/init').then((response) => {
                if (typeof response !== "undefined") {

                    let init_price_parameters = [];
                    if (response.price_parameters) {
                        response.price_parameters.map((t) => {
                            init_price_parameters.push(t.id);
                        });
                    }

                    setPriceParameter(init_price_parameters);

                    setForm(response);
                }
                setLoading(false);
            })
        }
        new Api().get(`/products/brands`).then((response) => {
            if (typeof response !== "undefined") {
                setBrands(response)
            }

        })
    }, []);

    const handleChangeElement = (event) => {
        let frm = form;
        frm[event.target.name] = event.target.value;
        setForm({...frm});
    };

    const handleChangeElementWithAutoComplete = (name, value) => {
        let frm = form;
        frm[name] = value;
        setForm({...frm})
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        let url = '/products/init';

        if (productID) {
            url = '/products/' + productID + '/init';

            let n_form = {...form};
            n_form['price_parameters'] = priceParameter;

            new Api().put(url, n_form).then((response) => {
                if (typeof response !== "undefined") {
                    if (response.status) {
                        setForm(response.model);
                        if (typeof onComplete !== undefined) {
                            onComplete(response.model.id);
                        }

                    } else {
                        toast.error(response.message ?? response.msg)
                    }

                    setLoading(false);
                }
            })
        } else {

            let n_form = {...form};
            n_form['price_parameters'] = priceParameter;

            new Api().post(url, n_form).then((response) => {
                if (typeof response !== "undefined") {
                    if (response.status) {
                        setForm(response.model);
                        if (typeof onComplete !== undefined) {
                            onComplete(response.model.id);
                        }

                    } else {
                        toast.error(response.message ?? response.msg)
                    }

                    setLoading(false);
                }
            })
        }



    };

    return(
        <form onSubmit={handleSubmit} className='animate__animated animate__fadeIn'>
            <Box mt={5}>
                <Paper style={{ padding: '25px'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <TextField
                                label="عنوان"
                                variant="outlined"
                                margin='dense'
                                value={form.title}
                                fullWidth
                                name='title'
                                onChange={handleChangeElement}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <TextField
                                label="هدینگ (h2)"
                                variant="outlined"
                                margin='dense'
                                value={form.heading}
                                fullWidth
                                name='heading'
                                onChange={handleChangeElement}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} >
                            <TextField
                                label="کد محصول"
                                variant="outlined"
                                margin='dense'
                                value={form.code}
                                fullWidth
                                name='code'
                                onChange={handleChangeElement}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            {
                                brands && brands.data && brands.data.length > 0 &&
                                <Autocomplete
                                    onChange={((event, value) => handleChangeElementWithAutoComplete('brand_id', value ? value.id : ''))}
                                    options={brands && brands.data}
                                    getOptionLabel={(option) => option.title}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            fullWidth
                                            name='brand_id'
                                            margin={"dense"}
                                            label="برند"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    }
                                />

                            }

                            {form.brand && <Chip label={form.brand.title} />}

                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Autocomplete
                                onChange={((event, value) => handleChangeElementWithAutoComplete('package_type_id', (value ? value.id : '') ))}
                                options={packageTypeReducer.entities.data}
                                getOptionLabel={(option) => option.title}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        fullWidth
                                        name='package_type_id'
                                        margin={"dense"}
                                        label="واحد اندازه گیری"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                }
                            />
                            {form.package_type && <Chip label={form.package_type.title} />}
                        </Grid>
                        <Grid item xs={12} sm={2} >
                            <FormControl variant="outlined" fullWidth size="small" margin={"dense"}>
                                <InputLabel id="basalam">وضعیت محصول در باسلام</InputLabel>
                                <Select
                                    labelId="basalam"
                                    id="basalam_state"
                                    value={+form.added_basalam}
                                    onChange={handleChangeElement}
                                    name={"added_basalam"}
                                    label="وضعیت محصول در باسلام"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>انتخاب نشده</em>
                                    </MenuItem>
                                    <MenuItem value={0}>ناموجود در باسلام</MenuItem>
                                    <MenuItem value={1}>موجود در باسلام</MenuItem>
                                    <MenuItem value={2} disabled={true}>اضافه شده، اما دارای خطا</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Autocomplete
                                multiple={true}
                                freeSolo={true}
                                onChange={((event, value) => {
                                    let priceParameters = priceParameter;
                                    value.forEach((value) => {
                                        priceParameters.push(value.id);
                                    });
                                    setPriceParameter(priceParameters);
                                })}
                                options={treeReducer.nodes}
                                getOptionLabel={(option) => option.title}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        fullWidth
                                        name='price_parameters'
                                        margin={"dense"}
                                        label="پارامترهای قیمتی"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                }
                            />
                            {form.price_parameters && form.price_parameters.map((item , index) => {
                                return(
                                    <Chip
                                        label={item.title}
                                        clickable
                                        color="default"
                                        onDelete={() => {
                                            // remove from form
                                            let price_parameters = form['price_parameters'];
                                            price_parameters.splice(index, 1);
                                            form['price_parameters'] = price_parameters;
                                            // remove from tag
                                            price_parameters = priceParameter;
                                            price_parameters.splice(index, 1);
                                            // init tag in form and tag const
                                            setForm({...form});
                                            setPriceParameter(price_parameters);
                                        }}
                                    />
                                )
                            })}
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
            <Box mt={2} className='display-flex display-flex-direction-row display-flex-justify-content-flex-end'>
                <Button disabled={loading} variant='contained' color='primary' type="submit">تکمیل اطلاعات</Button>
            </Box>
            {loading && <Loading/>}
        </form>
    );
})

const mapStateToProps = state => ({
    packageTypeReducer : state.packageTypeReducer,
    treeReducer: state.treeReducer
})

const mapDispatchToProps = (dispatch) => ({
    fetchPriceParameter: () => {
        dispatch(treeAction.priceParameters())
    },
    fetchPackageType: () => {
        dispatch(packageTypeAction.fetchPackageType())
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductBasicInfo);